import { render, staticRenderFns } from "./PodcastList.vue?vue&type=template&id=4aa5491d&scoped=true&"
import script from "./PodcastList.vue?vue&type=script&lang=js&"
export * from "./PodcastList.vue?vue&type=script&lang=js&"
import style0 from "./PodcastList.vue?vue&type=style&index=0&id=4aa5491d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5491d",
  null
  
)

export default component.exports